import { render, staticRenderFns } from "./ProductScorecard.vue?vue&type=template&id=11697b43"
import script from "./ProductScorecard.vue?vue&type=script&lang=js"
export * from "./ProductScorecard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports